export default __webpack_public_path__ + "static/media/add-image.5fc47ba9.jpg";